module.exports = __webpack_public_path__ + "img/Logo2.32813eb4.png";